import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../styles/InstantBbpsPayPage.css";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { fetchWalletPayOutCharges } from "../../Common/creditCardBinAPI/CommonFunctions";
import Cookies from "js-cookie";

// Icons (Material UI)
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { data } from "../../Common/Text/NormalText";

const InstantBbpsPayPage = () => {
  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in InstantBbpsPayPage ====>>", detailsToSend);
  const token = Cookies.get("token");
  const userDetails = useSelector((state) => state?.user?.user || {});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [amountValue, setAmountValue] = useState("");
  const [walletPayOutFee, setWalletPayOutFee] = useState(0);
  const [walletPayOutPercentage, setWalletPayOutPercentage] = useState(0);
  const [isEdit] = useState(false);

  // const amountToPay = Number(amountValue)
  const minAmount = 1
  const maxAmount = Number(detailsToSend?.billAmount) >= 200000 ? 200000 : detailsToSend?.billAmount;
  const numericAmount = Number(amountValue);
  const maxAmountEntering = Number(detailsToSend?.billAmount) >= 200000 ? 200000 : detailsToSend?.billAmount;
  const inValidAmount = (numericAmount < 0 || numericAmount > maxAmountEntering) && amountValue?.length > 0;

  const customerData = {
    logo: detailsToSend?.billerLogo || detailsToSend?.billLogo,
    serviceName: detailsToSend?.serviceName,
    cardName: detailsToSend?.subService,
    cardNumber:
      detailsToSend?.bbpsCreditCardNumber || detailsToSend?.creditCardNumber,
    name: detailsToSend?.billerResponse?.customerName,
    billAmount: detailsToSend?.billAmount,
  };

  console.log("detailsToSend?.billAmount ===>>", detailsToSend?.billAmount)

  useEffect(() => {
    const rawAmount = Number(detailsToSend?.billAmount);
    const billAmountInNumber = isNaN(rawAmount) ? 0 : rawAmount;
    const serviceName = detailsToSend?.serviceName?.toUpperCase?.();

    if (serviceName === "CREDIT CARD") {
      setAmountValue((prev) =>
        prev !== "" ? prev : billAmountInNumber.toString()
      );
    } else {
      setAmountValue((billAmountInNumber || 0).toString());
    }

    handleFetchPayoutCharges();
  }, []);

  const handleFetchPayoutCharges = async () => {
    try {
      const detailsForGeneralSchemes = {
        serviceName: detailsToSend?.serviceName,
        subService: detailsToSend?.serviceName,
      };

      let response;
      if (
        detailsToSend?.serviceName?.toUpperCase() === "CREDIT CARD" &&
        userDetails?.walletStatus?.toUpperCase() === "ACTIVE"
      ) {
        response = await fetchWalletPayOutCharges(
          userDetails,
          detailsForGeneralSchemes,
          token
        );
      } else {
        response = detailsToSend;
      }

      console.log("response in instant bbps page ====>>>", response);

      setWalletPayOutFee(response?.payOutFee || 0);
      setWalletPayOutPercentage(response?.payOutPercentage || 0);
    } catch (error) {
      console.error("Error fetching wallet payout charges:", error);
    }
  };

 const handleEnterAmount = (e) => {
  let value = e.target.value;

  // Remove any character except digits and dot
  value = value.replace(/[^0-9.]/g, "");

  // Allow only first dot
  const firstDotIndex = value.indexOf(".");
  if (firstDotIndex !== -1) {
    // Keep first dot, remove any other dot
    value =
      value.slice(0, firstDotIndex + 1) +
      value.slice(firstDotIndex + 1).replace(/\./g, "");
  }

  // Limit to 2 decimal places if dot exists
  if (value.includes(".")) {
    const [integerPart, decimalPart] = value.split(".");
    value = integerPart + "." + decimalPart.slice(0, 2);
  }

  setAmountValue(value);
};

  const handleContinue = () => {
    if (userDetails?.walletStatus?.toUpperCase() == "ACTIVE") {
      let payOutCharges = 0;
      if (detailsToSend?.serviceName?.toUpperCase() == "CREDIT CARD") {
        console.log("calculating credit card charges in instant bbps====>>")
        if (Number(walletPayOutFee) > 0) {
          payOutCharges = Number(walletPayOutFee);
        } else if (Number(walletPayOutPercentage) > 0) {
          payOutCharges = amountValue * (Number(walletPayOutPercentage) / 100);
        } else {
          alert("Permissions Denied. Contact support.");
          return;
        }
      }

      const totalAmount = Number(amountValue) + Number(payOutCharges);

      const details = {
        ...detailsToSend,
        actualAmount: amountValue,
        finalPayableAmount: totalAmount,
        billAmount: amountValue,
        billType: "billPayRequest",
        chargedAmount: payOutCharges,
        MerchantId: userDetails?.MerchantId,
        mobileNumber: userDetails?.mobileNumber,
        payOutChargedAmount: Number(payOutCharges),
        payOutFee: Number(walletPayOutFee),
        payOutPercentage: Number(walletPayOutPercentage),
        amount: totalAmount,
        transactionType: "Debit",
        userName: userDetails?.userName,
        payInRequired: "YES",
      };

      console.log("details in instant bbps pay page ======>>", details);

      dispatch(setDetailsToSend(details));
      navigate("/PaymentMethod", {
        state: {
          Selectedoperator: {},
          walletballance: Number(userDetails?.walletBalance),
          ntarTransactionId: detailsToSend?.ntarTransactionId,
          walletPayOutFee: Number(walletPayOutFee),
          walletPayOutPercentage: Number(walletPayOutPercentage),
        },
      });
    } else {
      const details = {
        ...detailsToSend,
        billAmount: amountValue,
        amount: amountValue,
        billType: "billPayRequest",
        MerchantId: userDetails?.MerchantId,
        mobileNumber: userDetails?.mobileNumber,
        paymentSource: "webappDummy",
        transactionType: "Debit",
        userName: userDetails?.userName,
        payInRequired: "YES",
      };

      console.log("details in instant bbps pay page ======>>", details);

      dispatch(setDetailsToSend(details));
      navigate("/PaymentMethod", {
        state: {
          Selectedoperator: {},
          walletballance: Number(userDetails?.walletBalance),
          ntarTransactionId: detailsToSend?.ntarTransactionId,
          walletPayOutFee: Number(walletPayOutFee),
          walletPayOutPercentage: Number(walletPayOutPercentage),
        },
      });
    }
  };

  const handleBbpsBack = () => navigate("/payScreen");

  const formatValue = (key, value) => {
    if (typeof value === "string" && value.length == 4) {
      return `XXXXXXXXXXXX${value.slice(-4)}`;
    }
    return value;
  };

  const changeFormatOfDateAndTime = (date) => {
    if (!date) return "";
    return date.split("-").reverse().join("-");
  };
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;

      if (!detailsToSend?.serviceName) {
        navigate("/BBPS", { replace: true });
      }
    }
  }, [detailsToSend?.serviceName]);

  return (
    <div className="credit-payment-container_s">
      <div className="header-credpay">
        <h1 style={{ fontSize: "1.2rem", fontWeight: "600", margin: "0px" }}>
          {detailsToSend?.serviceName} {data?.bill}
        </h1>
        <div className="header-actions">
          <button className="refer-btn">Refer User</button>
          <button className="more-btn">
            <MoreHorizIcon />
          </button>
        </div>
      </div>

      <div className="payment-form-creditcardpaymentpay">
        <div style={{ display: "flex", justifyContent: "start" }}>
          <KeyboardBackspaceIcon onClick={handleBbpsBack} fontSize="large" />
        </div>

        <div className="cdp-scale-s">
          <div className="cdp-amount-section">
            <h2>{data?.enterAmount}</h2>

            <div className="amount-input-creditcardpaymentpay">
              <div className="input-container-cdp">
                <input
                  type="text"
                  value={amountValue}
                  placeholder="₹ 0"
                  readOnly={isEdit}
                  onChange={handleEnterAmount}
                  className={inValidAmount ? "styled-input-cdp errorInput_s" : "styled-input-cdp"}
                />
              </div>
            </div>
          </div>

          <div className="customer-details_s">
            <div className="card-preview_s">
              <img src={customerData?.logo} alt="logo" width="40" />
              <div>
                <div>
                  {customerData?.serviceName} - {customerData?.cardName}
                </div>
                {customerData?.cardNumber && (
                  <div>XXXX{customerData?.cardNumber?.slice(-4)}</div>
                )}
              </div>
            </div>

            {(detailsToSend?.inputParams
              ? detailsToSend?.inputParams
              : detailsToSend?.parameters
              ? detailsToSend?.parameters
              : []
            ).map((paramObj, i) => (
              <div key={i} className="detailsRow_s">
                <div>{paramObj?.desc}</div>
                <div>{formatValue(paramObj?.desc, paramObj?.enteredValue)}</div>
              </div>
            ))}

            {detailsToSend?.CustomerName && (
              <div className="detailsRow_s">
                <div>{data.cusNo}</div>
                <div>{detailsToSend?.CustomerName}</div>
              </div>
            )}

            {detailsToSend?.billAmount &&
              Number(detailsToSend?.billAmount) != 0 && (
                <div className="detailsRow_s">
                  <div>{data.billAmount}</div>
                  <div>{detailsToSend?.billAmount}</div>
                </div>
              )}

            {detailsToSend?.outstandingDue &&
              Number(detailsToSend?.outstandingDue) != 0 && (
                <div className="detailsRow_s">
                  <div>{data.Outstanding}</div>
                  <div>{detailsToSend?.outstandingDue}</div>
                </div>
              )}

            {detailsToSend?.billDate && (
              <div className="detailsRow_s">
                <div>{data.billDate}</div>
                <div>{changeFormatOfDateAndTime(detailsToSend?.billDate)}</div>
              </div>
            )}

            {detailsToSend?.dueDate && (
              <div className="detailsRow_s">
                <div>{data.dueDate}</div>
                <div style={{ color: "red" }}>
                  {changeFormatOfDateAndTime(detailsToSend?.dueDate)}
                </div>
              </div>
            )}
          </div>
          {inValidAmount && (
            <p style={{ color: "red" }}>
              You can enter amount from {minAmount} to {maxAmount}
            </p>
          )}
          <p className="Note_s_wA">Note: Don't Refresh till the process is completed !</p>
          <button
            className="pay-button_s_i"
            disabled={!amountValue || inValidAmount}
            onClick={handleContinue}
          >
            {data?.pNow}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstantBbpsPayPage;
